
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lohp",
      function () {
        return require("private-next-pages/lohp/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lohp"])
      });
    }
  